import * as React from "react";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { CartSlider } from "./CartSlider.js";
import { useCart } from "../../../../../../context/Cart/context/Cart/context.js";
const CartSliderContainer = ({ children }) => {
  const { getLabel } = useIntl();
  const { cart } = useCart();
  const { isCartExpanded } = useFeatureToggles();
  return /* @__PURE__ */ React.createElement(CartSlider, { cart, title: getLabel("cart.title"), defaultExpanded: isCartExpanded }, children);
};
export {
  CartSliderContainer
};
//# sourceMappingURL=CartSliderContainer.js.map
